class GoToTop {
    constructor() {
        this.button = document.getElementById("go-to-top");
        this.scrollThreshold = 300;
        this.isVisible = false;

        this.init();
    }

    init() {
        if (!this.button) return;

        window.addEventListener("scroll", this.handleScroll.bind(this), {
            passive: true,
        });

        this.button.addEventListener("click", this.scrollToTop.bind(this));

        this.handleScroll();
    }

    handleScroll() {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
        const shouldShow = scrollTop > this.scrollThreshold;

        if (shouldShow && !this.isVisible) {
            this.show();
        } else if (!shouldShow && this.isVisible) {
            this.hide();
        }
    }

    show() {
        this.button.classList.add("go-to-top--visible");
        this.isVisible = true;
    }

    hide() {
        this.button.classList.remove("go-to-top--visible");
        this.isVisible = false;
    }

    scrollToTop() {
        this.hide();

        const scrollToTop = () => {
            const currentScroll =
                document.documentElement.scrollTop || document.body.scrollTop;

            if (currentScroll > 0) {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                });
            }
        };

        scrollToTop();

        setTimeout(() => {
            const main = document.getElementById("main");
            if (main) {
                main.focus();
            }
        }, 300);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new GoToTop();
});
